import React, { useEffect, useState } from 'react';
// style
import { WhatIDoWrapper } from './WhatIDo.style';
// axios
import axios from 'axios';
// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import  GlobalButton  from '../globalbutton/GlobalButton';
import ServiceCard from '../card/ServiceCard';

import useFetchData from '../../hooks/use-fetch-data';
import { Link } from 'react-router-dom';

function WhatIDo(props) {
    const { data } = useFetchData();
    const [ media, setMedia ] = useState([]);
   
    
    useEffect(() => {
        const fetchMedia = async () =>  {
            try {
                const {media: response } = await axios.get("/wp-json/wp/v2/media");
                setMedia(response);    
            } catch (error) {
                console.log(error.message)
            }
        }
        fetchMedia();
        console.log(media);
    },[]);

   

  return (
    <WhatIDoWrapper>
        <Container>
        <div className='what-i-do'>                     
            { data.map((item,index) => item.id === 7 ? 
                <div>
                    <Row> 
                        <Col md={6} className='d-flex flex-column align-items-start' key={index.id}>
                            <motion.div
                            initial={{ opacity: 0, x: 80 }}
                            whileInView={{ opacity: 1, x: 0, transition: { delay: 0.75, duration: 0.7} }}
                            viewport={{ once: true, amount: 1}}                            
                            dangerouslySetInnerHTML={{__html: item.acf.about_me_title}}/>
                            <motion.div 
                            initial={{ opacity: 0, y: 80 }}
                            whileInView={{ opacity: 1, y: 0, transition: { delay: 0.5, duration: 0.6} }}
                            viewport={{ once: true, amount: 1}} 
                            style={{
                                fontSize: '40px',
                                paddingTop: '30px',
                                paddingBottom: '30px'
                            }} dangerouslySetInnerHTML={{__html: item.acf.about_me_heading_title}} />
                            <motion.div 
                            initial={{opacity: 0, y: 60 }}
                            whileInView={{opacity: 1, y: 0, transition: {
                                type: 'tween',
                                duration: 0.8    
                            }}}
                            style={{ paddingBottom: '30px', textAlign: 'left', lineHeight: '35px'}}
                            dangerouslySetInnerHTML={{__html:item.acf.what_i_do_content}}
                            >
                            </motion.div>
                            <Link to="/about" className='cta-primary'>{item.acf.what_i_do_cta_text}</Link>
                        </Col>
                        <Col md={6} className='d-flex flex-column align-items-start'>
                            <img src={item.acf.about_me_background_image} width="100%" height="auto" />   
                        </Col> 
                    </Row>
                    </div>

              : null
        )}
        </div>
        </Container>
    </WhatIDoWrapper>
  )
}

export default WhatIDo